import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import {useGetCutouts} from "../../api/get-cutouts";
import {SelectedCutout} from "../../types/SelectedCutout";
import {CutoutControl} from "./CutoutControl";

export function CutoutsColumnControl({group}: { group: SelectedMaterial }) {
    const context = useCountertops();
    const cutouts = useGetCutouts(context.dealerId, group.prodQteGrpID ?? 0, context.customerZip);
    const [selectedCutouts, setSelectedCutouts] = useState<Map<number, SelectedCutout>>(new Map<number, SelectedCutout>());
    const [selectedLabors, setSelectedLabors] = useState<Map<number, number>>(new Map<number, number>());

    useEffect(() => {
        let map = new Map<number, SelectedCutout>();
        group.cutouts.forEach(item => {
            map.set(item.productID, item);
        });

        setSelectedCutouts(map);
    }, [group.cutouts])

    useEffect(() => {
        let map = new Map<number, number>();
        group.sinks.forEach(item => {
            if (item.laborProductID !== undefined){
                let qty = map.get(item.laborProductID);
                if (qty === undefined){
                    qty = 0;
                }
                qty = qty + (item.qty ?? 0);
                map.set(item.laborProductID, qty);
            }
        });

        setSelectedLabors(map);
    }, [group.sinks])


    if (cutouts.isLoading)
        return <></>

    return (
        <>
            {cutouts.data.map(cutout => {
                    let selectedCutout = selectedCutouts.get(cutout.productID);
                    let laborQty = selectedLabors.get(cutout.productID) ?? 0;
                    return <CutoutControl
                        key={cutout.productID}
                        cutout={cutout}
                        prodQteGrpID={group.prodQteGrpID}
                        selectedCutout={selectedCutout}
                        laborQty = {laborQty}
                    />
                }
            )}
        </>
    );
}
